import { Box, Heading, Text } from "@chakra-ui/react";
import { GetStaticProps } from "next";
import Link from "next/link";
import getInstallers from "../lib/getInstallers";

export const getStaticProps: GetStaticProps = async () => {
  const installers = await getInstallers();
  return {
    props: {
      installers,
    },
  };
};

export default function InstallerListPage({ installers }) {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  const installersByLetter = alphabet.map((letter) => {
    return {
      letter,
      installers: installers.filter((installer) => {
        return installer.name[0] === letter;
      }),
    };
  });

  return (
    <Box maxW={"800px"} ml={"auto"} mr={"auto"}>
      <Heading as="h1" size="md" mt={0} color="gray.500" mb={1}>
        {installers.length} Solar Installers
      </Heading>
      <Text>
        A full list of accredited installers or solar panels, heat pumps, and
        more.{` `}
        <a
          href={`/all-regions`}
          style={{
            fontWeight: "normal",
          }}
        >
          Click here to view installer by region.
        </a>
      </Text>

      {installersByLetter.map((letter) => {
        return (
          <Box key={letter.letter}>
            <Heading as="h2" size="md" mb={3}>
              {letter.letter}
            </Heading>
            {letter.installers.map((installer) => {
              return (
                <Box key={installer.slug} mb={1}>
                  <Link href={`/installers/${installer.slug}`} legacyBehavior>
                    <a>{installer.name}</a>
                  </Link>
                </Box>
              );
            })}
          </Box>
        );
      })}
    </Box>
  );
}
